import styled from "styled-components";

const TBody = styled.tbody `
  &::after {

  }
`;

export default TBody;
